const prepareShow = covenants => {
  return covenants
}

export default {
  prepareShow,

  onShow () {
    this.show = true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/resources/methods.js